export enum Routes {
  Quote = '/quote',
}
